import { createRoot } from "react-dom/client";
import { applyTheme } from "@vicreturns/ui/lib/applyTheme";
import { SubscribeForm } from "./components/SubscribeForm";
import "./types";
import "./styles/main.css";

function getCssHref(): string | null {
  const config = window.subscribeFormConfig;
  return config && typeof config.cssHref === "string" ? config.cssHref : null;
}

function renderIntoShadow(host: Element) {
  const element = host as HTMLElement;

  applyTheme(element);

  const shadow = element.shadowRoot ?? element.attachShadow({ mode: "open" });

  // Reset shadow content for idempotent renders
  shadow.innerHTML = "";

  // Attach stylesheet via <link> so @import in CSS resolves correctly
  const linkEl = document.createElement("link");
  linkEl.rel = "stylesheet";
  const cssHref = getCssHref();
  if (cssHref) {
    linkEl.href = cssHref;
    shadow.appendChild(linkEl);
  }

  const mount = document.createElement("div");
  shadow.appendChild(mount);

  createRoot(mount).render(<SubscribeForm />);
}

function initSubscribeForm() {
  const containers = document.querySelectorAll(".subscribe-form-container");
  containers.forEach((container) => {
    try {
      renderIntoShadow(container);
    } catch (error) {
      console.error("Failed to initialize subscribe form:", error);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSubscribeForm);
} else {
  initSubscribeForm();
}
